import React, { useState } from 'react';

import './CookieNotice.css';

const CookieNotice = () => {
    const [show, setShow] = useState(() => localStorage.getItem('agreement') === 'no');

    if (!show) return null;

    const agree = () => {
        localStorage.setItem('agreement', 'yes');
        setShow(false);
    };

    return (
        <div className="cookie-notice">
            <div className="cookie-notice-text">
                Сайт использует технологию{' '}
                <a href="https://agropogoda.com/static/files/cookie.docx" target="_blank" rel="noreferrer">
                    cookie
                </a>
                . Вы можете отказаться от использования cookie, выбрав соответствующие настройки в браузере, но
                это может повлиять на работу некоторых функций сайта. Используя сайт, вы соглашаетесь на
                обработку персональных данных на условиях, изложенных в{' '}
                <a href="https://agropogoda.com/static/files/privacy.pdf" target="_blank" rel="noreferrer">
                    Политике
                </a>
                .
            </div>
            <button type="button" className="cookie-notice-btn" onClick={agree}>
                Всё понятно
            </button>
        </div>
    );
};

export default CookieNotice;
